<template>
    <div>
        <h1 style="font-size: 24px; color: black;">优推广告配置</h1>
        <el-row>
            <el-col>
                <el-button type="primary" @click="showDetails">添加规则</el-button>
            </el-col>
        </el-row>
        <h1>
            <el-table border :data="list">
                <el-table-column prop="id" label="编号ID" align="center"></el-table-column>
                <el-table-column prop="name" label="规则名称" align="center"></el-table-column>
                <el-table-column  label="关联渠道" align="center">
                    <template slot-scope="scope" >
                        {{scope.row.subChannelName.length===0? " ":scope.row.subChannelName.join(" , ")}}
                    </template>
                </el-table-column>
                <el-table-column  label="操作" align="center">
                    <template slot-scope="scope">
                    <el-button type="text" @click="editDetails(scope.row)">编辑</el-button>
                    <el-button type="text" @click="removeAdRule(scope.row.id)">删除</el-button>
                 </template >
                </el-table-column>
            </el-table>
        </h1>

        <el-dialog title="添加规则" center :visible.sync="dialogAddVisible" width="800px">
            <el-form :model="addAdRuleForm">
                <el-form-item label="规则名称 :" :label-width="labelWidth">
                    <el-input  type="text" v-model="addAdRuleForm.name" maxlength="50" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="渠道筛选 :" :label-width="labelWidth">
                    <el-cascader  v-model="addAdRuleForm.subChannel" :options="channelList" :props="optionProps"
                                 clearable collapse-tags>
                    </el-cascader>
                </el-form-item>
                <el-form-item label="广告场景 :" :label-width="labelWidth">
                    <el-select  v-model="addAdRuleForm.scene" placeholder="请选择" multiple>
                        <el-option
                                v-for="item in scenes"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="选择时间 :" :label-width="labelWidth">
                    <el-select  v-model="addAdRuleForm.circle" placeholder="请选择">
                        <el-option
                                v-for="item in circles"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                    <el-tag type="warning" effect="plain">预留未实现</el-tag>
                </el-form-item>
                <el-form-item label="用户展现次数 :" :label-width="labelWidth">
                       <el-input-number  size="mini" :min="1" v-model="addAdRuleForm.newUserViews"></el-input-number>
                    <el-tag type="warning" effect="plain">预留未实现</el-tag>
                </el-form-item>
            </el-form>
            <div style="text-align: center;">
                <el-button type="primary" @click="confirmAdRuleForm" >提 交</el-button>
                <el-button type="info" @click="dialogAddVisible=false">取 消</el-button>
            </div>
        </el-dialog>
        <el-dialog title="编辑规则" center :visible.sync="dialogEditVisible" width="800px" >
            <el-form :model="editAdRuleForm">
                <el-form-item label="规则名称 :" :label-width="labelWidth">
                    <el-input  type="text" v-model="editAdRuleForm.name" maxlength="50" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="渠道筛选 :" :label-width="labelWidth">
                    <el-cascader
                            v-model="editAdRuleForm.subChannel"
                            :options="channelList"
                            :props="optionProps"
                            clearable
                            collapse-tags>
                    </el-cascader>
                </el-form-item>
                <el-form-item label="广告场景 :" :label-width="labelWidth">
                    <el-table  border :data="editAdRuleForm.adScenes">
                        <el-table-column prop="id" label="编号ID" align="center"></el-table-column>
                        <el-table-column prop="scene.name" label="广告场景" align="center"></el-table-column>
                        <el-table-column  label="开关" align="center">
                            <template slot-scope="scope">
                            <el-switch v-model="scope.row.open"
                                       :active-value="1"
                                       :inactive-value="0"
                                       active-text="开启"
                                       inactive-text="关闭">
                            </el-switch>
                         </template>
                        </el-table-column>
                    </el-table>
                </el-form-item>
                <el-form-item label="选择时间 :" :label-width="labelWidth">
                    <el-select  v-model="editAdRuleForm.circle" placeholder="请选择">
                        <el-option
                                v-for="item in circles"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                    <el-tag type="warning" effect="plain">预留未实现</el-tag>
                </el-form-item>
                <el-form-item label="用户展现次数 :" :label-width="labelWidth">
                    <el-input-number  size="mini" :min="1" v-model="editAdRuleForm.newUserViews"></el-input-number>
                    <el-tag type="warning" effect="plain">预留未实现</el-tag>
                </el-form-item>
            </el-form>
            <div style="text-align: center;">
                <el-button type="primary" @click="confirmEditAdRuleForm" >提 交</el-button>
                <el-button type="info" @click="cancelEditAdRuleForm">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {
        adRuleList,
        deleteAdRule,
        allSelectData,
        allScene,
        channelList,
        saveAdRule,
        updateAdRule

    } from '@/http/api'
    export default {
        name: "AdRule",
        data () {
            return {
                keyValue:0,
                dialogAddVisible:false,
                dialogEditVisible:false,
                labelWidth: '110px',
                circles:[],
                scenes:[],
                list:[],
                channelList:[],
                optionProps: {
                    emitPath: false,
                    multiple: true,
                    value: 'subChannel',
                    label: 'name',
                    children: 'children',
                },
                addAdRuleForm: {
                    id: 0,
                    name: '',
                    circle: 4,
                    newUserViews:0,
                    subChannel:[],
                    scene:[],
                },
                editAdRuleForm:{
                    id: 0,
                    name: '',
                    newUserViews:0,
                    circle:0,
                    subChannel:[],
                    adScenes:[],
                 }
            }
        },
        methods:{
            getList(){
                adRuleList().then(resp=> {
                    this.list= resp.data.info
                });
            },
            removeAdRule(id){
                this.$confirm('此操作将永久删除该规则, 是否继续?', '提示', {
                    cancelButtonClass: 'btn-custom-cancel',
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    deleteAdRule(id).then(resp=> {
                        if (resp.data.status === 0) {
                            this.getList();
                        }
                    });
                }).catch(() => {
                })
            },
            showDetails() {
                this.addAdRuleForm={
                    id: 0,
                    name: '',
                    circle: 4,
                    newUserViews:0,
                    subChannel: [],
                    scene:[0],
                };
                this.dialogAddVisible = true;
            },
            confirmAdRuleForm(){
                let _message = '';
                if(this.addAdRuleForm.name===''){
                    _message = '请输入活动名称'
                }else if (this.addAdRuleForm.subChannel.length<1){
                    _message = '请选择相关渠道'
                }
                if(_message){
                    this.$message({
                        message: _message,
                        type: 'error'
                    });
                    return;
                }
                saveAdRule(this.addAdRuleForm).then(resp=>{
                    if(resp.data.status===0){
                        this.getList();
                        this.dialogAddVisible=false;
                    }
                });
            },
            editDetails(data){
                this.dialogEditVisible = true;
                this.editAdRuleForm={
                        id: data.id,
                        name: data.name,
                        newUserViews:data.newUserViews,
                        circle:data.circle.id,
                        subChannel:data.subChannelIds,
                        adScenes:data.adScenes,
                }
            },
            confirmEditAdRuleForm(){
                let _message = '';
                if(this.editAdRuleForm.name===''){
                    _message = '请输入活动名称'
                }else if (this.editAdRuleForm.subChannel.length<1){
                    _message = '请选择相关渠道'
                }
                if(_message){
                    this.$message({
                        message: _message,
                        type: 'error'
                    });
                    return;
                }
                updateAdRule(this.editAdRuleForm).then(resp=>{
                    if(resp.data.status===0){
                        this.getList();
                        this.dialogEditVisible=false;
                    }
                });
            },
            cancelEditAdRuleForm(){
                this.getList();
                this.dialogEditVisible=false;
            }
        },
        created() {
            let _this = this;
            channelList().then(resp => {
                this.channelList = JSON.parse(JSON.stringify(resp.data.info)).map(channel => {
                    if (channel.children) {
                        channel.children = channel.children.filter(sub => sub.state === 1)
                    }
                    return channel;
                }).filter(channel => channel.children && channel.children.length);
                this.channelList.forEach(function (channel) {
                    _this.$set(channel, 'subChannel', channel.id);
                });
            });
            allScene().then(resp=>{
                this.scenes = resp.data.info;
            });
            allSelectData().then(resp=>{
                this.circles = resp.data.info.activityCircleTypes;
            });
            this.getList();
        }
    }
</script>

<style scoped>

</style>